/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).on('click','.giftingbox',function(){
var this_var = $('input.giftinp').val();
  $.ajax({
    type: 'POST',                            
    url: '/cart/add.js',
    dataType: 'json',                              
    data: {quantity:1,id:this_var},           
    success: function(cart){
      location.reload();
    }
  })
});